// src/data/productData.js
import { getImageUrl } from '@/utils/image';

// 首页超市图片列表
export const homeEquipmentList = [
    {id:1,cover:getImageUrl('home/bld-home-projects-Grocery in Japan.jpg'),title:'Grocery in Japan'},
    {id:2,cover:getImageUrl('home/bld-home-projects-Smoke Shop in New Zealand.jpg'),title:'Smoke Shop in New Zealand'},
    {id:3,cover:getImageUrl('home/bld-home-projects-Candy Store in Africa.jpg'),title:'Candy Store in Africa'},
    {id:4,cover:getImageUrl('home/bld-home-projects-Gift Store in America.jpg'),title:'Gift Store in America'},
    {id:5,cover:getImageUrl('home/bld-home-projects-Car Accessories Store in Australia.jpg'),title:'Car Accessories Store in Australia'},
    {id:6,cover:getImageUrl('home/bld-home-projects-Healthy Grocery in Canada.jpg'),title:'Healthy Grocery in Canada'},
    {id:7,cover:getImageUrl('home/bld-home-projects-Pharmacy in France.jpg'),title:'Pharmacy in France'},
    {id:8,cover:getImageUrl('home/bld-home-projects-First Aid Store in Australia.jpg'),title:'First Aid Store in Australia'},
    {id:9,cover:getImageUrl('home/bld-home-projects-Shopping Mall in Angola.jpg'),title:'Shopping Mall in Angola'}
];

// 首页优势列表
export const advantageList = [
    {id:3,cover:getImageUrl('advantage-3.jpg'),title:'Reliable Direct Factory',desc:'Direct Manufacturer Pricing: Our 6400 m² self-owned factory in Foshan (Nanhai District) combined with a robust network of 10+ partner facilities ensures premium quality at unbeatable factory-direct costs.'},
    {id:1,cover:getImageUrl('advantage-1.jpg'),title:'Guidance to open your shops',desc:'Backed by more than 20 years of retail industry leadership, we understand the pulse of modern supermarkets and stores. We guide you through every step of your store-opening journey. By actively listening to your needs, recommending the perfect fixture solutions, providing transparent cost budgeting, and flawlessly handling every logistic detail, we ensure your retail space is engineered for success.'},
    {id:2,cover:getImageUrl('advantage-2.jpg'),title:'Experienced designer team',desc:'Our elite team of specialized retail designers delivers end-to-end spatial solutions tailored to your brand. From comprehensive 3D store layouts and floor plans to precision product prototyping, we transform conceptual ideas into optimized retail environments. Explore our successful case studies and transparent pricing models below.'},
];

// 产品分类列表
export const productCategories = [
    {typeId: 1, typeName: 'Supermarket Gondola'},
    {typeId: 2, typeName: 'Warehouse Rack'},
    {typeId: 3, typeName: 'Glass Showcase'},
    {typeId: 4, typeName: 'Wooden Display'},
    {typeId: 5, typeName: 'Vegetable Rack'},
    {typeId: 6, typeName: 'Checkout Counter'},
    {typeId: 7, typeName: 'Shopping Cart'},
    {typeId: 8, typeName: 'Customizing Display'}
];

// 所有产品列表
export const allProducts = [
    {
        id: 1,
        typeId: 1,
        name: '4 Post Supermarket Shelf',
        description: 'High strength cold-rolled steel supermarket shelf, 50kg per layer',
        imageUrl: getImageUrl('product/supermarket-gondola-1.jpg'),
        model: 'HBE-SG-001'
    },
    {
        id: 2,
        typeId: 1,
        name: '4 Post Supermarket Gondola',
        description: 'Durable supermarket gondola with adjustable length options',
        imageUrl: getImageUrl('product/supermarket-gondola-2.jpg'),
        model: 'HBE-SG-002'
    },
    {
        id: 3,
        typeId: 1,
        name: '4 Post Supermarket Shelf',
        description: 'Versatile double-sided shelving for retail supermarkets',
        imageUrl: getImageUrl('product/supermarket-gondola-3.jpg'),
        model: 'HBE-SG-003'
    },
    {
        id: 4,
        typeId: 1,
        name: 'Supermarket Shelf',
        description: 'Heavy duty supermarket shelf, 80kg loading capacity per layer',
        imageUrl: getImageUrl('product/supermarket-gondola-4.jpg'),
        model: 'HBE-SG-004'
    },
    {
        id: 5,
        typeId: 1,
        name: 'Convenient Store/Supermarket Shelf',
        description: 'Compact shelf ideal for convenience stores and small supermarkets',
        imageUrl: getImageUrl('product/supermarket-gondola-5.jpg'),
        model: 'HBE-SG-005'
    },
    {
        id: 6,
        typeId: 1,
        name: 'Supermarket Wall Shelf with light box',
        description: 'Wall shelf with integrated light box for better product display',
        imageUrl: getImageUrl('product/supermarket-gondola-6.jpg'),
        model: 'HBE-SG-006'
    },
    {
        id: 7,
        typeId: 1,
        name: 'Wine Wall Stand with Header',
        description: 'Specialized wine display stand with header, 120kg per layer',
        imageUrl: getImageUrl('product/supermarket-gondola-7.jpg'),
        model: 'HBE-SG-007'
    },
/*    {
        id: 13,
        typeId: 4,
        name: 'Wooden Retail Display',
        description: 'Natural wooden display stand for boutiques',
        imageUrl: getImageUrl('product/bg.jpg'),
        model: 'HBE-SR-EU-22'
    },*/
/*    {
        id: 14,
        typeId: 5,
        name: 'Fruit Vegetable Rack',
        description: 'Multi-tier fresh produce display rack',
        imageUrl: getImageUrl('product/bg.jpg'),
        model: 'HBE-SR-EU-91'
    },*/
    {
        id: 15,
        typeId: 6,
        name: 'Checkout Counter Desk',
        description: 'Modern checkout counter with storage space',
        imageUrl: getImageUrl('product/bg.jpg'),
        model: 'HBE-SR-EU-04'
    },
    {
        id: 16,
        typeId: 7,
        name: 'Shopping Trolley Cart',
        description: 'Durable shopping cart for supermarkets',
        imageUrl: getImageUrl('product/bg.jpg'),
        model: 'HBE-SR-EU-85'
    },
    {
        id: 17,
        typeId: 8,
        name: 'Custom Display Solution',
        description: 'Tailored display solutions for your business needs',
        imageUrl: getImageUrl('product/bg.jpg'),
        model: 'HBE-SR-EU-17'
    },
    {
        id: 18,
        typeId: 3,
        name: 'Square Upright Wall Glass Showcase',
        description: 'Square upright wall glass showcase for retail display',
        imageUrl: getImageUrl('product/glass-showcase-1.jpg'),
        model: 'HBE-GS-001'
    },
    {
        id: 19,
        typeId: 3,
        name: 'Round Upright Wall Glass Showcase',
        description: 'Round upright wall glass showcase for retail display',
        imageUrl: getImageUrl('product/glass-showcase-2.jpg'),
        model: 'HBE-GS-002'
    },
    {
        id: 20,
        typeId: 3,
        name: 'Frameless Upright Wall Glass Showcase',
        description: 'Frameless upright wall glass showcase for retail display',
        imageUrl: getImageUrl('product/glass-showcase-3.jpg'),
        model: 'HBE-GS-003'
    },
    {
        id: 21,
        typeId: 3,
        name: 'See Through Upright Wall Glass Showcase',
        description: 'See through upright wall glass showcase for retail display',
        imageUrl: getImageUrl('product/glass-showcase-4.jpg'),
        model: 'HBE-GS-004'
    },
    {
        id: 22,
        typeId: 3,
        name: 'Tall & Short Glass Showcase Set',
        description: 'Tall and short glass showcase set for retail display',
        imageUrl: getImageUrl('product/glass-showcase-5.jpg'),
        model: 'HBE-GS-005'
    },
    {
        id: 23,
        typeId: 2,
        name: 'Light duty warehouse rack',
        description: 'Light duty warehouse rack',
        imageUrl: getImageUrl('product/warehouse-rack-1.jpg'),
        model: 'HBE-WR-001'
    },
    {
        id: 24,
        typeId: 2,
        name: 'Medium duty warehouse rack',
        description: 'Medium duty warehouse rack',
        imageUrl: getImageUrl('product/warehouse-rack-2.jpg'),
        model: 'HBE-WR-002'
    },
    {
        id: 25,
        typeId: 2,
        name: 'Medium duty warehouse rack',
        description: 'Medium duty warehouse rack',
        imageUrl: getImageUrl('product/warehouse-rack-3.jpg'),
        model: 'HBE-WR-003'
    },
    {
        id: 26,
        typeId: 2,
        name: 'Tool Rack',
        description: 'Tool Rack',
        imageUrl: getImageUrl('product/warehouse-rack-4.jpg'),
        model: 'HBE-WR-004'
    },
    {
        id: 27,
        typeId: 2,
        name: 'Heavy duty warehouse pallet rack',
        description: 'Heavy duty warehouse pallet rack',
        imageUrl: getImageUrl('product/warehouse-rack-5.jpg'),
        model: 'HBE-WR-005'
    },
    {
        id: 28,
        typeId: 4,
        name: 'Heavy Duty Wire Display Stand',
        description: 'Heavy Duty Wire Display Stand',
        imageUrl: getImageUrl('product/wooden-display-1.jpg'),
        model: 'HBE-WD-001'
    },
    {
        id: 29,
        typeId: 4,
        name: 'Light Duty Convenient Store Display Stand',
        description: 'Light Duty Convenient Store Display Stand',
        imageUrl: getImageUrl('product/wooden-display-2.jpg'),
        model: 'HBE-WD-002'
    },
    {
        id: 30,
        typeId: 4,
        name: 'Single Side Wooden Display Stand',
        description: 'Single Side Wooden Display Stand',
        imageUrl: getImageUrl('product/wooden-display-3.jpg'),
        model: 'HBE-WD-003'
    },
    {
        id: 31,
        typeId: 4,
        name: 'Island Wooden Display Stand',
        description: 'Island Wooden Display Stand',
        imageUrl: getImageUrl('product/wooden-display-4.jpg'),
        model: 'HBE-WD-004'
    },
    {
        id: 32,
        typeId: 5,
        name: 'Single Side Vegetable Rack',
        description: 'Single Side Vegetable Rack',
        imageUrl: getImageUrl('product/vegetable-rack-1.jpg'),
        model: 'HBE-VR-001'
    },
    {
        id: 33,
        typeId: 5,
        name: 'Island Vegetable Rack',
        description: 'Island Vegetable Rack',
        imageUrl: getImageUrl('product/vegetable-rack-2.jpg'),
        model: 'HBE-VR-002'
    },
    {
        id: 34,
        typeId: 5,
        name: 'Island Vegetable Combination',
        description: 'Island Vegetable Combination',
        imageUrl: getImageUrl('product/vegetable-rack-3.jpg'),
        model: 'HBE-VR-003'
    }
];

// 产品详情数据
export const productDetails = {
    1: {
        name: "4 Post Supermarket Shelf",
        title: "4 Post Supermarket Shelf",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/supermarket-gondola-1.jpg'),
        imageUrl2: getImageUrl('product/supermarket-gondola-1-detail.jpg'),
        specifications: [
            { label: "Description", value: "4 Post Supermarket Shelf" },
            { label: "Nomal Length", value: "800mm/1000mm/1250mm optional" },
            { label: "Loading Capacity", value: "50kg Per Layer" },
            { label: "Material", value: "High Strength Cold-rolled Steel" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    2: {
        name: "4 Post Supermarket Gondola",
        title: "4 Post Supermarket Gondola",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/supermarket-gondola-2.jpg'),
        specifications: [
            { label: "Description", value: "4 Post Supermarket Gondola" },
            { label: "Nomal Length", value: "800mm/1000mm/1250mm optional" },
            { label: "Loading Capacity", value: "50kg Per Layer" },
            { label: "Material", value: "High Strength Cold-rolled Steel" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    3: {
        name: "4 Post Supermarket Shelf",
        title: "4 Post Supermarket Shelf",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/supermarket-gondola-3.jpg'),
        specifications: [
            { label: "Description", value: "4 Post Supermarket Shelf" },
            { label: "Nomal Length", value: "800mm/1000mm/1250mm optional" },
            { label: "Loading Capacity", value: "50kg Per Layer" },
            { label: "Material", value: "High Strength Cold-rolled Steel" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    4: {
        name: "Supermarket Shelf",
        title: "Supermarket Shelf",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/supermarket-gondola-4.jpg'),
        specifications: [
            { label: "Description", value: "Supermarket Shelf" },
            { label: "Nomal Length", value: "800mm/1000mm/1250mm optional" },
            { label: "Loading Capacity", value: "80kg Per Layer" },
            { label: "Material", value: "High Strength Cold-rolled Steel" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    5: {
        name: "Convenient Store/Supermarket Shelf",
        title: "Convenient Store/Supermarket Shelf",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/supermarket-gondola-5.jpg'),
        specifications: [
            { label: "Description", value: "Convenient Store/Supermarket Shelf" },
            { label: "Nomal Length", value: "800mm/1000mm/1250mm optional" },
            { label: "Loading Capacity", value: "50kg Per Layer" },
            { label: "Material", value: "High Strength Cold-rolled Steel" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    6: {
        name: "Supermarket Wall Shelf with light box",
        title: "Supermarket Wall Shelf with light box",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/supermarket-gondola-6.jpg'),
        specifications: [
            { label: "Description", value: "Supermarket Wall Shelf with light box" },
            { label: "Nomal Length", value: "800mm/1000mm/1250mm optional" },
            { label: "Loading Capacity", value: "90kg Per Layer" },
            { label: "Material", value: "High Strength Cold-rolled Steel" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    7: {
        name: "Wine Wall Stand with Header",
        title: "Wine Wall Stand with Header",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/supermarket-gondola-7.jpg'),
        specifications: [
            { label: "Description", value: "Wine Wall Stand with Header" },
            { label: "Nomal Length", value: "800mm/1000mm/1250mm optional" },
            { label: "Loading Capacity", value: "120kg Per Layer" },
            { label: "Material", value: "High Strength Cold-rolled Steel" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    18: {
        name: "Square Upright Wall Glass Showcase",
        title: "Square Upright Wall Glass Showcase",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/glass-showcase-1.jpg'),
        specifications: [
            { label: "Description", value: "Square Upright Wall Glass Showcase" },
            { label: "Nomal Length", value: "900/1000mm/1200mm & customizingoptional" },
            { label: "Loading Capacity", value: "30kg Per Layer" },
            { label: "Material", value: "Aluminium alloy, tempered glass, MDF" },
            { label: "Color", value: "Black, white, red, gold, silver ect" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    19: {
        name: "Round Upright Wall Glass Showcase",
        title: "Round Upright Wall Glass Showcase",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/glass-showcase-2.jpg'),
        specifications: [
            { label: "Description", value: "Round Upright Wall Glass Showcase" },
            { label: "Nomal Length", value: "900/1000mm/1200mm & customizingoptional" },
            { label: "Loading Capacity", value: "30kg Per Layer" },
            { label: "Material", value: "Aluminium alloy, tempered glass, MDF" },
            { label: "Color", value: "Black, white, red, gold, silver ect" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    20: {
        name: "Frameless Upright Wall Glass Showcase",
        title: "Frameless Upright Wall Glass Showcase",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/glass-showcase-3.jpg'),
        specifications: [
            { label: "Description", value: "Frameless Upright Wall Glass Showcase" },
            { label: "Nomal Length", value: "900/1000mm/1200mm & customizingoptional" },
            { label: "Loading Capacity", value: "30kg Per Layer" },
            { label: "Material", value: "Aluminium alloy, tempered glass, MDF" },
            { label: "Color", value: "Black, white, red, gold, silver ect" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    21: {
        name: "See Through Upright Wall Glass Showcase",
        title: "See Through Upright Wall Glass Showcase",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/glass-showcase-4.jpg'),
        specifications: [
            { label: "Description", value: "See Through Upright Wall Glass Showcase" },
            { label: "Nomal Length", value: "900/1000mm/1200mm & customizingoptional" },
            { label: "Loading Capacity", value: "30kg Per Layer" },
            { label: "Material", value: "Aluminium alloy, tempered glass, MDF" },
            { label: "Color", value: "Black, white, red, gold, silver ect" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    22: {
        name: "Tall & Short Glass Showcase Set",
        title: "Tall & Short Glass Showcase Set",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/glass-showcase-5.jpg'),
        specifications: [
            { label: "Description", value: "Tall & Short Glass Showcase Set" },
            { label: "Nomal Length", value: "900/1000mm/1200mm & customizingoptional" },
            { label: "Loading Capacity", value: "30kg Per Layer" },
            { label: "Material", value: "Aluminium alloy, tempered glass, MDF" },
            { label: "Color", value: "Black, white, red, gold, silver ect" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    23: {
        name: "Light duty warehouse rack",
        title: "Light duty warehouse rack",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/warehouse-rack-1.jpg'),
        specifications: [
            { label: "Description", value: "Light duty warehouse rack" },
            { label: "Nomal Length", value: "1200mm/2000mm/2500mm optional" },
            { label: "Loading Capacity", value: "100/200/500/800kg Per Layer optional" },
            { label: "Material", value: "High Strength Cold-rolled Steel" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    24: {
        name: "Medium duty warehouse rack",
        title: "Medium duty warehouse rack",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/warehouse-rack-2.jpg'),
        specifications: [
            { label: "Description", value: "Medium duty warehouse rack" },
            { label: "Nomal Length", value: "1800/2000mm/2500mm/3000mm optional" },
            { label: "Loading Capacity", value: "500/800kg Per Layer optional" },
            { label: "Material", value: "High Strength Cold-rolled Steel" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    25: {
        name: "Medium duty warehouse rack",
        title: "Medium duty warehouse rack",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/warehouse-rack-3.jpg'),
        specifications: [
            { label: "Description", value: "Medium duty warehouse rack" },
            { label: "Nomal Length", value: "2000mm/2500mm/3000mm optional" },
            { label: "Loading Capacity", value: "500/800kg Per Layer optional" },
            { label: "Material", value: "High Strength Cold-rolled Steel" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    26: {
        name: "Tool Rack",
        title: "Tool Rack",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/warehouse-rack-4.jpg'),
        specifications: [
            { label: "Description", value: "Tool Rack" },
            { label: "Nomal Length", value: "2000mm/2500mm/3000mm optional" },
            { label: "Loading Capacity", value: "300/500kg Per Layer optional" },
            { label: "Material", value: "High Strength Cold-rolled Steel" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    27: {
        name: "Heavy duty warehouse pallet rack",
        title: "Heavy duty warehouse pallet rack",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/warehouse-rack-5.jpg'),
        specifications: [
            { label: "Description", value: "Heavy duty warehouse pallet rack" },
            { label: "Nomal Length", value: "1200/1500/2000mm/2500mm/3000mm optional" },
            { label: "Loading Capacity", value: "1~5 tons Per Layer optional" },
            { label: "Material", value: "High Strength Cold-rolled Steel" },
            { label: "Quality Assurance", value: "3 years(Suitable for high salt environment in coastal city)" }
        ]
    },
    28: {
        name: "Heavy Duty Wire Display Stand",
        title: "Heavy Duty Wire Display Stand",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/wooden-display-1.jpg'),
        specifications: [
            { label: "Description", value: "Heavy Duty Wire Display Stand" },
            { label: "Nomal Length", value: "900/1000mm/1200mm & customizing optional" },
            { label: "Loading Capacity", value: "100kg Per Layer" },
            { label: "Material", value: "Aluminium alloy, tempered glass, MDF" },
            { label: "Color", value: "Black, white, red, yellow and valid colors optional" },
            { label: "Quality Assurance", value: "3 years (Suitable for high salt environment in coastal city)" }
        ]
    },
    29: {
        name: "Light Duty Convenient Store Display Stand",
        title: "Light Duty Convenient Store Display Stand",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/wooden-display-2.jpg'),
        specifications: [
            { label: "Description", value: "Light Duty Convenient Store Display Stand" },
            { label: "Nomal Length", value: "900/1000mm/1200mm & customizing optional" },
            { label: "Loading Capacity", value: "50kg Per Layer" },
            { label: "Material", value: "Aluminium alloy, tempered glass, MDF" },
            { label: "Color", value: "Black, white, red, yellow and valid colors optional" },
            { label: "Quality Assurance", value: "3 years (Suitable for high salt environment in coastal city)" }
        ]
    },
    30: {
        name: "Single Side Wooden Display Stand",
        title: "Single Side Wooden Display Stand",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/wooden-display-3.jpg'),
        specifications: [
            { label: "Description", value: "Single Side Wooden Display Stand" },
            { label: "Nomal Length", value: "900/1000mm/1200mm & customizing optional" },
            { label: "Loading Capacity", value: "30kg Per Layer" },
            { label: "Material", value: "Aluminium alloy, tempered glass, MDF" },
            { label: "Color", value: "Black, white, red, yellow and valid colors optional" },
            { label: "Quality Assurance", value: "3 years (Suitable for high salt environment in coastal city)" }
        ]
    },
    31: {
        name: "Island Wooden Display Stand",
        title: "Island Wooden Display Stand",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/wooden-display-4.jpg'),
        specifications: [
            { label: "Description", value: "Island Wooden Display Stand" },
            { label: "Nomal Length", value: "Customized size" },
            { label: "Loading Capacity", value: "50kg Per Layer" },
            { label: "Material", value: "Aluminium alloy, tempered glass, MDF" },
            { label: "Color", value: "Black, white, red, yellow and valid colors optional" },
            { label: "Quality Assurance", value: "3 years (Suitable for high salt environment in coastal city)" }
        ]
    },
    32: {
        name: "Single Side Vegetable Rack",
        title: "Single Side Vegetable Rack",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/vegetable-rack-1.jpg'),
        specifications: [
            { label: "Description", value: "Single Side Vegetable Rack" },
            { label: "Nomal Length", value: "600/1200mm" },
            { label: "Loading Capacity", value: "50kg Per Layer" },
            { label: "Material", value: "Plastic, Cold-rolled Steel" },
            { label: "Color", value: "Black" },
            { label: "Quality Assurance", value: "3 years (Suitable for high salt environment in coastal city)" }
        ]
    },
    33: {
        name: "Island Vegetable Rack",
        title: "Island Vegetable Rack",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/vegetable-rack-2.jpg'),
        specifications: [
            { label: "Description", value: "Island Vegetable Rack" },
            { label: "Nomal Length", value: "900mm" },
            { label: "Loading Capacity", value: "50kg Per Layer" },
            { label: "Material", value: "Cold-rolled Steel" },
            { label: "Color", value: "Black" },
            { label: "Quality Assurance", value: "3 years (Suitable for high salt environment in coastal city)" }
        ]
    },
    34: {
        name: "Island Vegetable Combination",
        title: "Island Vegetable Combination",
        introduction: "If you are opening a new store or refurbishing an old supermarket make sure to take advantage of our complimentary Grocery & Supermarket design consultation and services. We will give you a retail solutions within 24 hours.",
        imageUrl1: getImageUrl('product/vegetable-rack-3.jpg'),
        specifications: [
            { label: "Description", value: "Island Vegetable Combination" },
            { label: "Nomal Length", value: "900mm" },
            { label: "Loading Capacity", value: "50kg Per Layer" },
            { label: "Material", value: "Cold-rolled Steel" },
            { label: "Color", value: "Black & Green" },
            { label: "Quality Assurance", value: "3 years (Suitable for high salt environment in coastal city)" }
        ]
    }
};

// 关于我们-制造与规模列表
export const manufacturingList = [
    {id:1,cover:getImageUrl('about/aboutus-manufacturing-1.jpg'),title:'Guidance to open your shops',desc:'Backed by more than 20 years of retail industry leadership, we understand the pulse of modern supermarkets and stores. We guide you through every step of your store-opening journey. By actively listening to your needs, recommending the perfect fixture solutions, providing transparent cost budgeting, and flawlessly handling every logistic detail, we ensure your retail space is engineered for success.'},
    {id:2,cover:getImageUrl('about/aboutus-manufacturing-2.jpg'),title:'Experienced designer team',desc:'Our elite team of specialized retail designers delivers end-to-end spatial solutions tailored to your brand. From comprehensive 3D store layouts and floor plans to precision product prototyping, we transform conceptual ideas into optimized retail environments. Explore our successful case studies and transparent pricing models below.'},
    {id:3,cover:getImageUrl('about/aboutus-manufacturing-3.jpg'),title:'Reliable Direct Factory',desc:'Direct Manufacturer Pricing: Our 6400 m² self-owned factory in Foshan (Nanhai District) combined with a robust network of 10+ partner facilities ensures premium quality at unbeatable factory-direct costs.'}
];

// 关于我们-产品组合列表
export const portfolioList = [
    {id: 1, cover: getImageUrl('about/aboutus-Portfolio-1.jpg')},
    {id: 2, cover: getImageUrl('about/aboutus-Portfolio-2.jpg')},
    {id: 3, cover: getImageUrl('about/aboutus-Portfolio-3.jpg')},
    {id: 4, cover: getImageUrl('about/aboutus-Portfolio-4.jpg')},
    {id: 5, cover: getImageUrl('about/aboutus-Portfolio-5.jpg')},
    {id: 6, cover: getImageUrl('about/aboutus-Portfolio-6.jpg')},
    {id: 7, cover: getImageUrl('about/aboutus-Portfolio-7.jpg')},
    {id: 8, cover: getImageUrl('about/aboutus-Portfolio-8.jpg')}
];
// 关于我们-产品认证列表
export const certifiedList = [
    {id: 1, cover: getImageUrl('about/aboutus-Certified-1.jpg')}
];

// 辅助函数：根据分类ID获取产品列表
export function getProductsByCategory(categoryId) {
    return allProducts.filter(product => product.typeId === categoryId);
}

// 辅助函数：根据产品ID获取产品详情
export function getProductById(productId) {
    return productDetails[productId] || null;
}
